import React from "react";

/** Admin shell tabs: key matches local state in AdminPage (`users` | `departments` | `levels`). */
export const ADMIN_TABS = [
  {
    key: "users",
    labelKey: "adminManagement.tabs.users",
    icon: (
      <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor">
        <path strokeWidth="1.5" d="M17 21v-2a4 4 0 0 0-4-4H7a4 4 0 0 0-4 4v2" />
        <circle cx="9" cy="7" r="4" strokeWidth="1.5" />
        <path strokeWidth="1.5" d="M16 3.13a4 4 0 0 1 0 7.75" />
      </svg>
    ),
  },
  {
    key: "departments",
    labelKey: "adminManagement.tabs.departments",
    icon: (
      <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor">
        <path strokeWidth="1.5" d="M3 21V5a2 2 0 0 1 2-2h6l4 4v14H3z" />
        <path strokeWidth="1.5" d="M11 3v4h4" />
      </svg>
    ),
  },
  // {
  //   key: "levels",
  //   label: "Risk Assessment",
  //   icon: (
  //     <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor">
  //       <path strokeWidth="1.5" d="M12 9v4m0 4h.01" />
  //       <path
  //         strokeWidth="1.5"
  //         d="M10.29 3.86 1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"
  //       />
  //     </svg>
  //   ),
  // },
];
